import { useCatalogueId, useCatalogueProducts } from 'modules/products'

import { UserGender } from 'typings/graphql'


type Props = {
  gender: UserGender
}

export const useTopRatedProducts = ({ gender }: Props) => {
  const catalogueName: ProductsModule.CatalogueName = gender === 'MALE' ? 'colognes' : 'perfumes'
  const { catalogueId, isFetching: isFetchingCatalogue } = useCatalogueId({ catalogueName })

  const { data, isFetching } = useCatalogueProducts({
    variables: {
      id: catalogueId,
      input: {
        limit: 6,
        sort: 'RATING_DESC',
      },
    },
    ssr: false,
    skip: !catalogueId,
  })

  return {
    isFetching: isFetchingCatalogue || isFetching,
    products: data?.products,
  }
}
